import React from 'react';
import useDocumentTitle from '../useDocumentTitle'
import image8 from "../../img/fourd1.png"
import image7 from "../../img/fourd2.png"
import image6 from "../../img/fourd3.png"
import image5 from "../../img/fourd4.png"
import image4 from "../../img/fourd5.png"
import image3 from "../../img/fourd6.png"
import image2 from "../../img/fourd7.png"
import image1 from "../../img/fourd8.png"


import NavbarLearn from '../navbarLearn';
import Sidebar from '../learnSidebar';

export default function FourD() {
    useDocumentTitle("Chapter 4 Lesson D | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">04-D</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">MOTORS</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">LESSON 4-D</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full h-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">LESSON OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Recognize the the different commonly-used motors in FRC.</p>
                        <p class="font-productsans text-base text-black mt-5">You'll be introduced to the advantages and disadvantages of each motor in ths lesson - to skip ahead, click on the chapter roadmap below:</p>
                        <a href="/learn/four">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 4</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">MECHANICAL BASICS</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/a">Tools and Machinery</a>
                                    <p class="font-productsans font-normal ml-3">Learn about common tools in your workshop and how to use them safely.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/b">Tool Size Guide</a>
                                    <p class="font-productsans font-normal ml-3">A reference for sizing - it gets confusing sometimes!</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/c">Gears, Chains, and Belts</a>
                                    <p class="font-productsans font-normal ml-3">Understand how and when to use gears, chains, and belts.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/d">Motors</a>
                                    <p class="font-productsans font-normal ml-3">Learn about the different FRC-legal motors.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/e">Drive Trains</a>
                                    <p class="font-productsans font-normal ml-3">Learn about the most important part of your robot - without this, it's useless.</p>
                                </li>
                            </ul>
                        </div>
                        <h class="block font-scoutcond font-black italic text-[5rem] leading-none mt-20">MOTORS</h>
                        <p class="font-productsans text-lg text-black">motors are what makes your robot move. There are many different types designated by FIRST, and each has their strengths and weaknesses. This lesson will go over a few of the many accepted types.</p>

                        <p class="font-productsans font-bold text-2xl text-black mt-10 ">Vex Pro 775/Redline 775</p>
                        
                        <img src={image1} class="my-5 rounded-[1rem]" alt="vex pro 775"></img>
                        <img src={image2} class="my-5 rounded-[1rem]" alt="redline 775"></img>

                        <p class="font-productsans text-lg text-black">The 775 is a type of frc motor that is manufactured by a variety of different companies, each with their special spin on the product. </p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Quick Info:</p>
                        <p class="font-productsans text-lg text-black"> - Brushed open-case motor</p>
                        <p class="font-productsans text-lg text-black"> - Runs at a very high free speed</p>
                        <p class="font-productsans text-lg text-black"> - Small size and relatively lightweight</p>

                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Statistics:</p>
                        <p class="font-productsans text-lg text-black"> - Free Speed 18750 rpm </p>
                        <p class="font-productsans text-lg text-black"> - Free current: 0.7 A</p>
                        <p class="font-productsans text-lg text-black"> - Maximum Power: 347 W</p>
                        <p class="font-productsans text-lg text-black"> - Stall Torque: 0.71N-m (or 6.28 in-lbs)</p>
                        <p class="font-productsans text-lg text-black"> - Stall Current: 134A</p>
                        <br></br>
                        <p class="font-productsans font-bold text-2xl text-black mt-10 ">Vex Falcon 500</p>
                        
                        <img src={image3} class="my-5 rounded-[1rem]" alt="falcon 500"></img>

                        <p class="font-productsans text-lg text-black"> The Falcon 500 is the most commonly used motor in FRC. Although it can be quite costly, the benefits of this motor negate the price.</p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Quick Info:</p>
                        <p class="font-productsans text-lg text-black"> - Brushless motor</p>
                        <p class="font-productsans text-lg text-black"> - One of the best motors available to FRC teams for its power and efficiency</p>
                        <p class="font-productsans text-lg text-black"> - Peak Efficiency 87%</p>
                        <p class="font-productsans text-lg text-black"> - Integrated motor controller</p>


                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Statistics:</p>
                        <p class="font-productsans text-lg text-black"> - Free Speed 6380 rpm </p>
                        <p class="font-productsans text-lg text-black"> - Free current: 1.5 A</p>
                        <p class="font-productsans text-lg text-black"> - Maximum Power: 783 W</p>
                        <p class="font-productsans text-lg text-black"> - Stall Torque: 4.69 N-m (or 41.51 in-lbs)</p>
                        <p class="font-productsans text-lg text-black"> - Stall Current: 257A</p>
                        <br></br>

                        <p class="font-productsans font-bold text-2xl text-black mt-10 ">Rev Robotics NEO</p>
                        
                        <img src={image4} class="my-5 rounded-[1rem]" alt="NEO"></img>

                        <p class="font-productsans text-lg text-black"> The NEO is another commonly used motor in FRC. Although it does not have an integrated motor controller, is enjoyed for its smaller profile and similar output power. </p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Quick Info:</p>
                        <p class="font-productsans text-lg text-black"> - Brushless motor</p>
                        <p class="font-productsans text-lg text-black"> - Requires REV SPARKS MAX motor controller</p>
                        <p class="font-productsans text-lg text-black"> - Comparable to Falcon 500, but SPARKS MAX is more difficult to code</p>


                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Statistics:</p>
                        <p class="font-productsans text-lg text-black"> - Free Speed 5676 rpm </p>
                        <p class="font-productsans text-lg text-black"> - Free current: 1.8 A</p>
                        <p class="font-productsans text-lg text-black"> - Maximum Power: 406 W</p>
                        <p class="font-productsans text-lg text-black"> - Stall Torque: 3.75 N-m</p>
                        <p class="font-productsans text-lg text-black"> - Stall Current: 150 A</p>
                        <br></br>
                        <p class="font-productsans font-bold text-2xl text-black mt-10 ">Rev Robotics NEO 550</p>
                        
                        <img src={image5} class="my-5 rounded-[1rem]" alt="NEO 550"></img>

                        <p class="font-productsans text-lg text-black"> The NEO 550 is the smaller sister version of the NEO. It's power output is scaled down significantly, but its size footprint is the smallest in FRC.  </p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Quick Info:</p>
                        <p class="font-productsans text-lg text-black"> - Size is comparable to a large grape!</p>
                        <p class="font-productsans text-lg text-black"> - Requires REV SPARKS MAX motor controller</p>
                        <p class="font-productsans text-lg text-black"> - Very useful in small spaces and operations where less power is needed.</p>



                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Statistics:</p>
                        <p class="font-productsans text-lg text-black"> - Free Speed 11000 rpm </p>
                        <p class="font-productsans text-lg text-black"> - Free current: 100 A</p>
                        <p class="font-productsans text-lg text-black"> - Maximum Power: 279 W</p>
                        <p class="font-productsans text-lg text-black"> - Stall Torque: 0.97 N-m (Much lower than other motors)</p>
                        <p class="font-productsans text-lg text-black"> - Stall Current: 100 A</p>
                        <br></br>
                        <p class="font-productsans font-bold text-2xl text-black mt-10 ">CIM Class</p>
                        
                        <img src={image6} class="my-5 rounded-[1rem]" alt="CIM"></img>

                        <p class="font-productsans text-lg text-black"> The CIM is one of the older FRC motors. Although it is used less today, some teams still use this for heavy-duty operations. </p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Quick Info:</p>
                        <p class="font-productsans text-lg text-black"> - Brushed motor (less efficient)</p>
                        <p class="font-productsans text-lg text-black"> - Requires motor controller</p>
                        <p class="font-productsans text-lg text-black"> - 4 mounting holes on a 2" bolt circles</p>


                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Statistics:</p>
                        <p class="font-productsans text-lg text-black"> - Free Speed 5330 rpm </p>
                        <p class="font-productsans text-lg text-black"> - Free current: 2.7 A</p>
                        <p class="font-productsans text-lg text-black"> - Maximum Power: 337 W</p>
                        <p class="font-productsans text-lg text-black"> - Stall Torque: 2.41 N-m</p>
                        <p class="font-productsans text-lg text-black"> - Stall Current: 131 A</p>
                        <br></br>
                        <p class="font-productsans font-bold text-2xl text-black mt-10 ">Mini-CIM Class</p>
                        
                        <img src={image7} class="my-5 rounded-[1rem]" alt="CIM"></img>

                        <p class="font-productsans text-lg text-black"> The Mini-CIM is a smaller version of the CIM. Although it is used less today, some teams still use this for heavy-duty operations. </p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Quick Info:</p>
                        <p class="font-productsans text-lg text-black"> - Brushed motor (less efficient)</p>
                        <p class="font-productsans text-lg text-black"> - A smaller size allows for it to be placed in smaller areas</p>
                        <p class="font-productsans text-lg text-black"> - 2/3 of the power of a normal cim</p>


                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Statistics:</p>
                        <p class="font-productsans text-lg text-black"> - Free Speed  5830 rpm </p>
                        <p class="font-productsans text-lg text-black"> - Free current: 3 A</p>
                        <p class="font-productsans text-lg text-black"> - Maximum Power: 215 W</p>
                        <p class="font-productsans text-lg text-black"> - Stall Torque: 1.4 N-m</p>
                        <p class="font-productsans text-lg text-black"> - Stall Current: 89 A</p>
                        <br></br>

                        <p class="font-productsans font-bold text-2xl text-black mt-10 ">BAG Motor</p>
                        
                        <img src={image8} class="my-5 rounded-[1rem]" alt="BAG"></img>

                        <p class="font-productsans text-lg text-black"> The BAG is one of the oldest FRC motors. It is one of the least used motors due to its low output to weight ratio. </p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Quick Info:</p>
                        <p class="font-productsans text-lg text-black"> - Brushed motor (less efficient)</p>
                        <p class="font-productsans text-lg text-black"> - Requires motor controller</p>
                        <p class="font-productsans text-lg text-black"> - Used for medium-power applications. </p>


                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">Statistics:</p>
                        <p class="font-productsans text-lg text-black"> - Free Speed 1300 rpm </p>
                        <p class="font-productsans text-lg text-black"> - Free current: 1.8 A</p>
                        <p class="font-productsans text-lg text-black"> - Maximum Power: 149 W</p>
                        <p class="font-productsans text-lg text-black"> - Stall Torque: 0.4 N-m</p>
                        <p class="font-productsans text-lg text-black"> - Stall Current: 53 A</p>
                        <br></br>
                    </div>
                </div>
            </div>
        </div>
    )
}